export default "__VITE_ASSET__BdXObTNy__"